// src/pages/commercial/CommercialExportPage.js
import React, { useState } from 'react';
import CommercialLayout from '../../components/commercial/CommercialLayout';
import { useAuth } from '../../contexts/AuthContext';
import pb from '../../lib/pocketbase';

export default function CommercialExportPage() {
    const { user } = useAuth();
    const [loading, setLoading] = useState(false);
    const [exportType, setExportType] = useState('customers'); // customers | deals

    const handleExport = async () => {
        setLoading(true);
        try {
            let data = [];
            let filename = '';

            if (exportType === 'customers') {
                data = await pb.collection('customers').getFullList({
                    sort: '-created',
                    filter: `created_by = "${user.id}" || commercial_id = "${user.id}"`
                });
                filename = `clients_export_${new Date().toISOString().slice(0, 10)}.csv`;
            } else if (exportType === 'deals') {
                data = await pb.collection('deals').getFullList({
                    sort: '-created',
                    filter: `owner = "${user.id}"`
                });
                filename = `deals_export_${new Date().toISOString().slice(0, 10)}.csv`;
            }

            if (data.length === 0) {
                alert("Aucune donnée à exporter.");
                setLoading(false);
                return;
            }

            // Convert to CSV
            const headers = Object.keys(data[0]).filter(k => typeof data[0][k] !== 'object' || data[0][k] === null); // Simple filter
            const csvContent = [
                headers.join(','), // Header row
                ...data.map(row => headers.map(fieldName => {
                    let val = row[fieldName];
                    if (val === null || val === undefined) return '';
                    if (typeof val === 'string') return `"${val.replace(/"/g, '""')}"`; // Escape quotes
                    return val;
                }).join(','))
            ].join('\n');

            // Download
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

        } catch (err) {
            console.error("Export error", err);
            alert("Erreur lors de l'export.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <CommercialLayout title="Centre d'Export">
            <div className="commercial-page-wrapper">
                <style>{`
                .commercial-page-wrapper {
                    --admin-panel: var(--commercial-panel, #fff);
                    --admin-panel-2: var(--commercial-panel-2, #f9fafb);
                    --admin-border: var(--commercial-border, #e2e8f0);
                    --admin-text: var(--commercial-text, #0f172a);
                    --admin-muted: var(--commercial-muted, #64748b);
                    --admin-accent: var(--commercial-accent, #4f46e5);
                }
                .export-card {
                    background: var(--admin-panel);
                    border: 1px solid var(--admin-border);
                    border-radius: 16px;
                    padding: 32px;
                    max-width: 600px; margin: 40px auto;
                    text-align: center;
                    box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
                }
                .option-grid {
                    display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin: 32px 0;
                }
                .option-card {
                    border: 2px solid var(--admin-border);
                    border-radius: 12px; padding: 20px;
                    cursor: pointer; transition: all 0.2s;
                    background: var(--admin-panel-2);
                    display: flex; flex-direction: column; align-items: center; gap: 12px;
                }
                .option-card:hover { border-color: var(--admin-accent); background: var(--admin-panel); transform: translateY(-2px); }
                .option-card.active { border-color: var(--admin-accent); background: rgba(79, 70, 229, 0.05); color: var(--admin-accent); }
                
                .btn-export {
                    background: var(--admin-accent); color: white; border: none;
                    padding: 14px 32px; border-radius: 12px; font-weight: 600; font-size: 1.1rem;
                    cursor: pointer; transition: all 0.2s;
                    display: inline-flex; align-items: center; gap: 12px;
                }
                .btn-export:hover { transform: translateY(-2px); filter: brightness(1.1); box-shadow: 0 10px 20px -5px rgba(79, 70, 229, 0.4); }
                .btn-export:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }
                `}</style>

                <h1 style={{ textAlign: 'center', marginBottom: 12, fontSize: '1.8rem' }}>Centre d'Export</h1>
                <p style={{ textAlign: 'center', color: 'var(--admin-muted)', marginBottom: 0 }}>
                    Téléchargez vos données pour vos analyses ou campagnes emailing.
                </p>

                <div className="export-card">
                    <h3 style={{ margin: 0 }}>1. Choisissez le type de données</h3>

                    <div className="option-grid">
                        <div
                            className={`option-card ${exportType === 'customers' ? 'active' : ''}`}
                            onClick={() => setExportType('customers')}
                        >
                            <span style={{ fontSize: '2.5rem' }}>👥</span>
                            <span style={{ fontWeight: 600 }}>Mes Clients</span>
                        </div>
                        <div
                            className={`option-card ${exportType === 'deals' ? 'active' : ''}`}
                            onClick={() => setExportType('deals')}
                        >
                            <span style={{ fontSize: '2.5rem' }}>💼</span>
                            <span style={{ fontWeight: 600 }}>Mon Pipeline</span>
                        </div>
                    </div>

                    <h3 style={{ margin: 0 }}>2. Lancez l'export</h3>
                    <div style={{ marginTop: 24 }}>
                        <button className="btn-export" onClick={handleExport} disabled={loading}>
                            {loading ? (
                                <><span>⏳</span> Génération du fichier...</>
                            ) : (
                                <><span>📥</span> Télécharger .CSV</>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </CommercialLayout>
    );
}
